<template>
  <div class="d-flex align-items-center justify-content-center min-vh-100">
    <b-container>
      <b-row class="justify-content-center">
        <b-col cols="12" md="6" lg="4">
          <b-card class="p-3 shadow-sm rounded-lg">
            <div class="text-center">
              <b-link :to="{ name: 'Login' }">
                <img :src="appLogoImage" class="img-fluid" width="150" />
              </b-link>
            </div>
            <b-card-title
              title-tag="h2"
              class="font-weight-bold text-center mt-3"
            >
              Check Your Email
            </b-card-title>
            <b-card-text class="text-muted text-center">
              Please check your email <strong>{{ email }}</strong> for instructions to reset your password.
            </b-card-text>

            <validation-observer ref="verificationCodeFormValidation">
              <b-form class="auth-login-form mt-3" @submit.prevent="validateForm">
                <b-form-group label-for="verification-code">
                  <validation-provider #default="{ errors }" name="Verification Code" rules="required">
                    <b-form-input
                      id="verification_code"
                      v-model="verification_code"
                      type="number"
                      maxlength="6"
                      class="form-control text-center"
                      placeholder="Enter Verification Code"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <b-button type="submit" variant="primary" class="mt-2" block>
                  Continue
                </b-button>
              </b-form>
            </validation-observer>

            <div class="text-center pt-3">
              <p class="text-muted">
                Haven’t received a code?
                <b-link class="font-weight-bold text-primary" @click="resendCode">
                  Resend Code
                </b-link>
              </p>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import { $themeConfig } from "@themeConfig";
import { mapActions, mapGetters } from "vuex";
import util from "@/util.js";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  props: {
    email: {
      type: String,
      required: true,
    },
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [util],
  data() {
    return {
      verification_code: "",
      required,
      appLogoImage: "",
    };
  },
  created() {
    this.appLogoImage = $themeConfig.app.appLogoImage;
  },
  methods: {
    ...mapActions({ checkResetCode: "appData/checkResetCode", requestReset: "appData/requestReset" }),

    async validateForm() {
      const success = await this.$refs.verificationCodeFormValidation.validate();
      if (success) {
        await this.submit();
      }
    },

    async submit() {
      try {
        const res = await this.checkResetCode({ payload: { email: this.email, code: this.verification_code } });
        if (res.status === 200) {
          this.$router.push({ name: "NewPassword", params: { email: this.email, verification_code: this.verification_code } });
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: { title: "Invalid or expired reset code.", variant: "danger", icon: "BellIcon" },
        }, { position: "top-right" });
      }
    },

    async resendCode() {
      try {
        const res = await this.requestReset({ payload: { email: this.email } });
        if (res.status === 200) {
          this.$toast({
            component: ToastificationContent,
            props: { title: "Code resent successfully!", variant: "success", icon: "BellIcon" },
          }, { position: "top-right" });
        }
      } catch (error) {
        this.displayError(error);
      }
    },
  },
  computed: {
    ...mapGetters({ hasRole: "appData/hasRole" }),
  },
};
</script>

<style scoped>
/* Mobile-friendly input spacing */
.b-form-input {
  text-align: center;
}
</style>
